import React, {useRef} from "react";
import Benefits from "../components/landing/Benefits";
import CTA from "../components/landing/CTA";
import emailjs from '@emailjs/browser';

function ContactPage() {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form.current, {
                publicKey: 'YOUR_PUBLIC_KEY',
            })
            .then(
                () => {
                    console.log('SUCCESS!');
                },
                (error) => {
                    console.log('FAILED...', error.text);
                },
            );
    };

    return (
        <>
            <section className="hero-section section-padding">
                <div className="w-layout-blockcontainer container w-container">
                    <div data-w-id="2948cf26-c4ba-bbe9-d8ff-eb4c04404e17" 
                         className="content-wrapper testimonial-hero">
                        <div className="section-title center">
                            <p className="label">Contact</p>
                            <div className="title center">
                                <h1 className="heading-1 text-align-center">Get in Touch with GeoLight</h1>
                                <p className="section-subtitle center">
                                    Experience the TSF Cloud Monitoring of the with Secure and Transparent and
                                    Decentralized Solutions
                                </p>
                            </div>
                        </div>
                        <div className="contact-address">
                            <div className="contact-address-wrapper">
                                <div className="single-contact-address stoke">
                                    <div className="contact-content-wrapper">
                                        <div className="title center">
                                            <div className="benefit-icon-wrapper">
                                                <img
                                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e65c9a7cfb2ef43a2c12bd_direct-inbox.svg"
                                                    loading="lazy" alt="" className="icon"/>
                                            </div>
                                            <div className="contact-content">
                                                <h4 className="heading-5">Email Address</h4>
                                                <a href="mailto:contact@geolight.co.za?subject=Contact"
                                                   className="body-text-16">contact@geolight.co.za</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="w-node-e0ec8a18-2da8-0f76-5638-7571b3dca132-ddc5e097"
                                     className="single-contact-address stoke">
                                    <div className="contact-content-wrapper">
                                        <div className="title center">
                                            <div className="benefit-icon-wrapper">
                                                <img
                                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e65c9a8e6ab0d678e2d925_call-calling.svg"
                                                    loading="lazy" alt="" className="icon"/>
                                            </div>
                                            <div className="contact-content">
                                                <h4 className="heading-5">Phone</h4>
                                                <a href="tel:+27112345678"
                                                   className="body-text-16">+27 11 234 5678</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="w-node-c5a300ce-70ff-a823-99dd-06bbfb1bb6be-ddc5e097"
                                     className="single-contact-address stoke">
                                    <div className="contact-content-wrapper">
                                        <div className="title center">
                                            <div className="benefit-icon-wrapper">
                                                <img
                                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e65c9a8b339554989dd3f2_messages-2.svg"
                                                    loading="lazy" alt="" className="icon"/>
                                            </div>
                                            <div className="contact-content">
                                                <h4 className="heading-5">Live Chat</h4>
                                                <a href="mailto:workinfo@web3go.co?subject=Contact"
                                                   className="body-text-16">@geolight</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className="body-text-16 text-align-center width-960">
                                Whether you &#x27;re a complete beginner curious about TSF cloud monitoring or a seasoned
                                user seeking insights into the latest trends, we &#x27;ll provide informative articles,
                                explain complex concepts in clear language, and showcase the applications. So, join us as
                                we unlock the mysteries of TSF cloud monitoring and explore the exciting possibilities
                                it holds for the future!
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contact section-padding">
                <div className="w-layout-blockcontainer container w-container">
                    <div data-w-id="44130a78-0466-a8d4-6bde-6b77b0115ef6" 
                         className="content-wrapper contact">
                        <div className="section-title center">
                            <p className="label">Contact sales</p>
                            <div className="title center">
                                <h2 className="heading-2 text-align-center">Contact With Our Sales</h2>
                                <p className="section-subtitle center">
                                    Experience the Future of the TSF cloud monitoring with Secure, Transparent and
                                    Decentralized Solutions
                                </p>
                            </div>
                        </div>
                        <div className="single-contact-address stoke">
                            <div className="contact-form-wrapper">
                                <div className="form-wrapper w-form">
                                    <form id="wf-form-Contact-Form" name="wf-form-Contact-Form" data-name="Contact Form"
                                          method="get" className="contact-form"
                                          data-wf-page-id="66e658e34f137113ddc5e097"
                                          data-wf-element-id="e56cb1d5-1c62-eb4c-1ffc-e6a97a04db2e">
                                        <div className="form-items-wrapper">
                                            <div className="form-item-wrapper">
                                                <label htmlFor="First-Name" className="body-text-16 text-neutral-01">First
                                                    Name *</label>
                                                <input className="input-item body-text-16 w-input" maxLength="256"
                                                       name="First-Name" data-name="First Name"
                                                       placeholder="Your first name" type="text" id="First-Name"
                                                       required=""/>
                                            </div>
                                            <div className="form-item-wrapper">
                                                <label htmlFor="Last-Name" className="body-text-16 text-neutral-01">Last
                                                    Name *</label>
                                                <input className="input-item body-text-16 w-input" maxLength="256"
                                                       name="Last-Name" data-name="Last Name"
                                                       placeholder="Your last name" type="text" id="Last-Name"
                                                       required=""/>
                                            </div>
                                        </div>
                                        <div className="form-item-wrapper">
                                            <label htmlFor="Email" className="body-text-16 text-neutral-01">Email
                                                *</label>
                                            <input className="input-item body-text-16 w-input" maxLength="256"
                                                   name="Email" data-name="Email" placeholder="youremail@gmail.com"
                                                   type="email" id="Email" required=""/>
                                        </div>
                                        <div className="form-item-wrapper">
                                            <label htmlFor="Massage" className="body-text-16 text-neutral-01">Write
                                                Message</label>
                                            <textarea placeholder="Write your message here" maxLength="5000"
                                                      id="Massage" name="Massage" data-name="Massage"
                                                      className="text-field body-text-16 w-input"></textarea>
                                        </div>
                                        <input type="submit" data-wait="Please wait..."
                                               className="submit-button bg-theme-color-01 button-text w-button"
                                               value="Send Message"/>
                                    </form>
                                    <div className="w-form-done">
                                        <div>Thank you! Your submission has been received!</div>
                                    </div>
                                    <div className="w-form-fail">
                                        <div>Oops! Something went wrong while submitting the form.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Benefits />
            <CTA />
        </>
    )
}

export default ContactPage;